import React, { useEffect, useMemo, useState } from 'react';
import CustomerManagementTable from './CustomerManagementTable';
import Main from '../Main';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AddCustomerModal from './AddCustomerModal';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../Buttons/Buttons';
import CustomerFilterModal from './CustomerFilterModal';
import CustomerValueFilterModal from './CustomerValueFilterModal';
import CustomerViewDetails from './CustomerViewDetails';
import Download from '../MainSection/Download/Download';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { downloadCompanyDatas, loadCompanyData, loadCustomerCustomFieldData, loadCustomFieldsForCustomers, loadCustomviews, loadSingleCompanyData, postSwitchToClientDatas, postSwitchToSuperAdminDatas } from '../../redux/action';
import moment from 'moment';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import * as HeaderAuthentication from '../HeaderAuthentication';
import { baseURL } from '../BaseUrl';
import { Highlighter, Typeahead } from 'react-bootstrap-typeahead';

const CustomerManagement = () => {

    let dispatch = useDispatch();
    let location = useLocation();
    const navigate = useNavigate();
    // const { id: userRefId } = useParams();
    const { selectedDashboardID } = location.state || {};

    const { companyData = [] } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);
    const { companyDataDownload = [] } = useSelector((state) => state.data);

    const { singleCustomerData } = useSelector((state) => state.data);
    // const { modulePermissions } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { customFieldsForCustomers } = useSelector((state) => state.data);
    const { customerCustomFieldData } = useSelector((state) => state.data);

    const [moduleData, setModuleData] = useState(null);
    const [showImageDiv, setShowImageDiv] = useState(false);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const signInType = signInDetails ? signInDetails[0].SignInType : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));
    const PreviousSuperAdminID = JSON.parse(sessionStorage.getItem('PreviousSuperAdminID'));

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;
    const userRefId = location.state?.refId;
    const swithClientModuleId = location.state;

    // useEffect(() => {
    //     if (moduleId && storedModulePermissions.length) {
    //         // Find the module data using the moduleId
    //         const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
    //         setModuleData(module);
    //     }
    // }, [storedModulePermissions, moduleId]);

    // useEffect(() => {
    //     if (moduleId && storedModulePermissions.length) {
    //         // Find the module data using the moduleId
    //         const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
    //         setModuleData(module);
    //     } else if (swithClientModuleId && storedModulePermissions.length) {
    //         // Fallback logic if moduleId is undefined but swithClientModuleId is available
    //         const module = storedModulePermissions.find((m) => m.Modules_IDPK === swithClientModuleId);
    //         setModuleData(module);
    //     }
    // }, [storedModulePermissions, moduleId, swithClientModuleId]);

    useEffect(() => {
        const targetId = moduleId || swithClientModuleId;

        if (targetId && storedModulePermissions.length) {
            let foundModule = null;

            outerLoop:
            for (const sidebarMenu of storedModulePermissions) {
                for (const mainModule of sidebarMenu.MainModules || []) {
                    for (const subModule of mainModule.SubModules || []) {
                        if (subModule.ModuleID === targetId) {
                            foundModule = subModule;
                            break outerLoop;
                        }
                    }
                }
            }

            setModuleData(foundModule);
        }
    }, [storedModulePermissions, moduleId, swithClientModuleId]);

    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [companyCode, setCompanyCode] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([
        "ID", "COMPANY CODE", "COMPANY", "NAME", "NO.OF.LICENSE",
        "EMAIL", "ADDRESS", "START DATE", "END DATE", "STATUS", "ACTION"
    ]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [searchParams, setSearchParams] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [showSwitchModal, setShowSwitchModal] = useState(false); // For new modal
    const [selected, setSelected] = useState([]);
    const [customFields, setCustomFields] = useState([]);
    const [fieldValues, setFieldValues] = useState({});
    const [checkedData, setCheckedData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);

    // useEffect(() => {
    //     if (userRefId) {
    //         dispatch(loadSingleCompanyData(null, userRefId));
    //     } else {
    //         customerManagementData();
    //     }
    // }, [userRefId]);

    const customerManagementData = () => {
        dispatch(loadCompanyData(setLoading, rowsPerPage, page + 1, searchQuery, searchParams));
    }
    useEffect(() => {
        customerManagementData();
    }, [searchQuery, searchParams, page, rowsPerPage]);

    useEffect(() => {
        dispatch(downloadCompanyDatas(setLoading, searchQuery, searchParams));
    }, [])

    useEffect(() => {
        if (fromDate && toDate) {
            // Format the dates using moment.js
            const formattedFromDate = moment(fromDate).format('DD-MMM-YYYY'); // e.g., 01-Jan-2025
            const formattedToDate = moment(toDate).format('DD-MMM-YYYY');     // e.g., 15-Jan-2025

            // Build the WHERE clause with formatted dates
            const whereClause = `CONVERT(DATE,Company_StartDate,101) >= CONVERT(DATE,'${formattedFromDate}',101) AND CONVERT(DATE,Company_EndDate,101) <= CONVERT(DATE,'${formattedToDate}',101)`;

            // Update the searchParams state with the final WHERE clause
            setSearchParams(whereClause);
        } else {
            // Clear date filter if no dates are selected
            setSearchParams('');
        }
    }, [fromDate, toDate]); // The dependencies include fromDate, toDate, and searchText

    useEffect(() => {
        dispatch(loadCustomFieldsForCustomers());
    }, [])

    useEffect(() => {
        if (customFieldsForCustomers) {
            setCustomFields(customFieldsForCustomers);
        }
    }, [customFieldsForCustomers]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (comCode, comId) => {
        if (comId && comCode) {
            dispatch(loadSingleCompanyData(comCode, comId, setDataLoading))
            setCompanyCode(comCode);
            setCompanyId(comId); // Reset or set to null
            dispatch(loadCustomerCustomFieldData(setLoading, comId))
        } else if (comCode && !comId) {
            dispatch(loadSingleCompanyData(comCode, comId, setDataLoading))
            setCompanyCode(comCode);
            setCompanyId("");
        } else {
            setCompanyCode("");
            setCompanyId("");
        }

        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };

    const [selectedColumnValue, setSelectedColumnValue] = useState("");
    const [selectedColumnId, setSelectedColumnId] = useState("");
    const handleOpenValueFilterModal = (columnId = null, columnValue = null) => {
        setShowFilterMenu(false);
        setSelectedColumnId(columnId);
        setSelectedColumnValue(columnValue);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    useEffect(() => {
        if (userRefId) {
            setShowCustomerViewDetails(true);
            dispatch(loadSingleCompanyData(null, userRefId, setDataLoading));
            setCompanyCode(userRefId);
        } else {
            setShowCustomerViewDetails(false);
            setCompanyCode("");
            customerManagementData();
        }
    }, [userRefId, dispatch]);


    const handleViewDetails = (comCode) => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
        if (comCode) {
            dispatch(loadSingleCompanyData(comCode, null, setDataLoading))
            setCompanyCode(comCode);
        } else {
            setCompanyCode("");
        }
    }

    const handleCloseViewDetails = () => {
        setShowCustomerViewDetails(false);
    }

    const handleSwitchClientConfirm = (e) => {
        e.preventDefault();

        // Store PreviousSuperAdminID before switching
        if (signInDetails.length > 0) {
            sessionStorage.setItem("PreviousSuperAdminID", signInDetails[0]?.SuperAdminID ?? "null");
            sessionStorage.setItem("PreviousSuperAdminName", signInDetails[0]?.UserName ?? "null");
            sessionStorage.setItem("PreviousSuperAdminEmailId", signInDetails[0]?.EmailID ?? "null");
            sessionStorage.setItem("PreviousSuperAdminImage", signInDetails[0]?.Image ?? "null");
            sessionStorage.setItem("PreviousSuperAdminSignInType", signInDetails[0]?.SignInType ?? "null");
        }

        let SigninID = null;

        if (signInType === "SuperAdmin") {
            SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
        } else if (signInType === "ClientAdmin") {
            SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
        } else if (signInType === "User") {
            SigninID = signInDetails[0].UserID; // Use UserID for User type
        }

        const data = {
            "SigninID": PreviousCompanyID ? PreviousSuperAdminID : SigninID,
            "CompanyID": companyId
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };
        dispatch(postSwitchToClientDatas(requestOption, handleSwitchClientCancel, navigate));
    };

    const handleSwitchClientCancel = () => {
        setShowSwitchModal(false);
        setShowImageDiv(false);
    };

    const handleOpenBusinessUnitModal = () => {
        setIsModalOpen(false);
        setBusinessUnitModal(true);
    }
    const handleCloseBusinessUnitModal = () => {
        setBusinessUnitModal(false);
    }
    const handleBackHeadQuarters = () => {
        setBusinessUnitModal(false);
        setIsModalOpen(true);
    }
    const handleOpenBranchPlantModal = () => {
        setBusinessUnitModal(false);
        setBranchPlantModal(true);
    }
    const handleCloseBranchPlantModal = () => {
        setBranchPlantModal(false);
    }
    const handleBackBusinessUnit = () => {
        setBusinessUnitModal(true);
        setBranchPlantModal(false);
    }

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    // Handle the search input change (when selecting an item from Typeahead)
    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        const selectedCompanyId = query.CompanyID;
        setSearchQuery(selectedCompanyId); // Update searchQuery
        setSearchText(query); // Update searchText
        setSelected(selected);
    };

    const signInId =
        signInType === "SuperAdmin"
            ? signInDetails?.[0]?.SuperAdminID
            : signInType === "ClientAdmin"
                ? signInDetails?.[0]?.CompanyID
                : signInType === "User"
                    ? signInDetails?.[0]?.UserID
                    : null;

    const handleAnalyticsClick = () => {
        // if (customViews[0]?.IsDefault === true) {
        //     dispatch(loadCustomviews(null, signInType, signInId, 2));
        // }
        dispatch(loadCustomviews(null, signInType, signInId, 2));
        navigate('/dashboard', { state: { selectedDashboardID } })
    }

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(null);
        setToDate(null);
        customerManagementData();
        setSelected([]);
    }

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = companyData?.map(item => ({
            "ID": item.CompanyID || "NA",
            "COMPANY CODE": item.CompanyCode || "NA",
            "COMPANY": item.CompanyName || "NA",
            "NAME": item.ContactPerson || "NA",
            "NO.OF.LICENSE": item.NoOfLicenses || "NA",
            "EMAIL": item.EmailID || "NA",
            "ADDRESS": item.Address || "NA",
            "START DATE": item.StartDate || "NA",
            "END DATE": item.EndDate || "NA",
            "STATUS": item.Status || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Company");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'customer_management.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("License Management Data", 14, 20);

        const dataToExport = companyDataDownload?.map(item => ([
            item.CompanyID || "NA",
            item.CompanyCode || "NA",
            item.CompanyName || "NA",
            item.ContactPerson || "NA",
            item.NoOfLicenses || "NA",
            item.EmailID || "NA",
            item.Address || "NA",
            item.StartDate || "NA",
            item.EndDate || "NA",
            item.Status || "NA",
        ])) || [];

        const columns = [
            { title: "ID", dataKey: "id" },
            { title: "COMPANY CODE", dataKey: "companyCode" },
            { title: "COMPANY", dataKey: "company" },
            { title: "NAME", dataKey: "name" },
            { title: "NO.OF.LICENSE", dataKey: "no.of.license" },
            { title: "EMAIL", dataKey: "email" },
            { title: "ADDRESS", dataKey: "address" },
            { title: "START DATE", dataKey: "startDate" },
            { title: "END DATE", dataKey: "endDate" },
            { title: "STATUS", dataKey: "status" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'left',
            },
        });

        // Save PDF
        doc.save('customer_management.pdf');
    };

    const handleDownloadWord = () => {
        if (!companyData || companyData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = companyData.map(item => [
            String(item?.CompanyID || "NA"),  // Explicitly convert to string
            String(item?.CompanyCode || "NA"),  // Explicitly convert to string
            String(item?.CompanyName || "NA"),  // Explicitly convert to string
            String(item?.ContactPerson || "NA"),  // Explicitly convert to string
            String(item?.NoOfLicenses || "NA"),  // Explicitly convert to string
            String(item?.EmailID || "NA"),  // Explicitly convert to string
            String(item?.Address || "NA"),  // Explicitly convert to string
            String(item?.StartDate || "NA"),  // Explicitly convert to string
            String(item?.EndDate || "NA"),  // Explicitly convert to string
            String(item?.Status || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "ID", "COMPANY CODE", "COMPANY", "NAME", "NO.OF.LICENSE", "EMAIL",
            "ADDRESS", "START DATE", "END DATE", "STATUS",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Customer Management System",
            title: "Customer Management Report",
            description: "A detailed report of customer management.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "customer_management.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!companyData || companyData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = companyData.map(item => [
            item.CompanyID || "NA",
            item.CompanyCode || "NA",
            item.CompanyName || "NA",
            item.ContactPerson || "NA",
            item.NoOfLicenses || "NA",
            item.EmailID || "NA",
            item.Address || "NA",
            item.StartDate || "NA",
            item.EndDate || "NA",
            item.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "ID", "COMPANY CODE", "COMPANY", "NAME", "NO.OF.LICENSE", "EMAIL",
            "ADDRESS", "START DATE", "END DATE", "STATUS",
        ];

        // Create HTML table for printing
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Customer Management Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>Customer Management Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!companyData || companyData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = companyData.map(item => [
            item.CompanyID || "NA",
            item.CompanyCode || "NA",
            item.CompanyName || "NA",
            item.ContactPerson || "NA",
            item.NoOfLicenses || "NA",
            item.EmailID || "NA",
            item.Address || "NA",
            item.StartDate || "NA",
            item.EndDate || "NA",
            item.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "ID", "COMPANY CODE", "COMPANY", "NAME", "NO.OF.LICENSE", "EMAIL",
            "ADDRESS", "START DATE", "END DATE", "STATUS",
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'customer_management_report.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    const handleEmailWithCsvDownload = async () => {
        const companyDatas = Array.isArray(companyData) ? companyData : [companyData];

        if (!companyDatas || companyDatas.length === 0) {
            // toast.error("No user data to export.");
            console.log("No company data to export.");
            return;
        }

        const dataToExport = companyDatas?.map(item => ({
            "ID": item.CompanyID || "NA",
            "COMPANY CODE": item.CompanyCode || "NA",
            "COMPANY": item.CompanyName || "NA",
            "NAME": item.ContactPerson || "NA",
            "NO.OF.LICENSE": item.NoOfLicenses || "NA",
            "EMAIL": item.EmailID || "NA",
            "ADDRESS": item.Address || "NA",
            "START DATE": item.StartDate || "NA",
            "END DATE": item.EndDate || "NA",
            "STATUS": item.Status || "NA",
        })) || [];

        const headers = Object.keys(dataToExport[0]);
        const csvRows = [headers.join(",")];
        dataToExport.forEach(row => {
            const values = headers.map(header => `"${String(row[header]).replace(/"/g, '""')}"`);
            csvRows.push(values.join(","));
        });

        const csvContent = "\uFEFF" + csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const base64 = await blobToBase64(blob);

        const sessionData = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
        const signInType = sessionData[0]?.SignInType;
        let userID = null;

        if (signInType === "SuperAdmin") userID = sessionData[0]?.SuperAdminID;
        else if (signInType === "ClientAdmin") userID = sessionData[0]?.CompanyID;
        else if (signInType === "User") userID = sessionData[0]?.UserID;

        fetch(`${baseURL}/excomatixservices/api/Mail/PostAttachCSVDocument`, {
            method: "POST",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                UserID: userID,
                FileName: "customer_data.csv",
                File: base64.split(',')[1],
            }),
        })
            .then(res => res.json())
            .then(resp => {
                if (resp.Success === 1 && resp.FilePath) {
                    // toast.success("CSV uploaded successfully.");
                    console.log("CSV uploaded successfully.");

                    const subject = encodeURIComponent("CSV File: Customer Data");
                    const body = encodeURIComponent(
                        `Hi,\n\nPlease find the link to download the CSV file below:\n\n${resp.FilePath}\n\nThanks!`
                    );

                    // No "to" address, user can enter manually
                    window.location.href = `mailto:?subject=${subject}&body=${body}`;
                } else {
                    // toast.error("Upload failed. " + (resp.Msg || ""));
                    console.log("Upload failed. " + (resp.Msg || ""));
                }
            })
            .catch(err => {
                console.error("Upload Error:", err);
                // toast.error("Error uploading CSV file.");
            });
    };

    const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    const processedCompanyData = useMemo(() => {
        return companyData.map(item => ({
            ...item,
            CompanyCode: String(item.CompanyCode || 'N/A'),
            CompanyName: String(item.CompanyName || 'N/A'),
            ContactPerson: String(item.ContactPerson || 'N/A'),
            EmailID: String(item.EmailID || 'N/A'),
            Mobile: String(item.Mobile || 'N/A'),
            NoOfLicenses: String(item.NoOfLicenses || 'N/A'),
        }));
    }, [companyData]);

    return (
        <div className="customer-management-container">
            {!showCustomerViewDetails && <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                        onEmailCsvClick={handleEmailWithCsvDownload}
                    // customViews={customViews}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>{location.state?.isSwitchToClient ? "Select Customer from the list" : "License Management"}</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                {/* <div className='customermanagement-header-btns filter-btn'>
                                <Button><img src={filterIcon} alt="" className='filter-img' />Filters</Button>
                            </div> */}
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => { handleOpenValueFilterModal("", "") }}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        {/* <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        /> */}
                                        <Typeahead
                                            id="search-typeahead"
                                            className='typeahead-search'
                                            onChange={handleSearchChange}
                                            options={processedCompanyData}  // Use company names as options
                                            labelKey="CompanyName" // We are using a string (the company name), so we just use the string directly
                                            filterBy={['CompanyCode', 'CompanyName', 'ContactPerson', 'EmailID', 'Mobile', 'NoOfLicenses']}
                                            placeholder="Search Company"
                                            value={searchText}
                                            selected={selected}
                                            onInputChange={(input) => setSearchText(input)} // Update searchText with typed value
                                            minLength={1} // Minimum characters before suggestions appear
                                            autoFocus={false} // Prevent auto focusing on input
                                            renderMenu={(results, menuProps) => {
                                                // ✅ Hide table if an item is selected
                                                if (selected.length > 0 || !results.length) {
                                                    return null;
                                                }

                                                return (
                                                    <div {...menuProps} className='typeahead-search-options-table'>
                                                        <table className="table table-sm  mb-0">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th style={{ 'minWidth': '150px' }}>Comapany Code</th>
                                                                    <th style={{ 'minWidth': '150px' }}>Comapany Name</th>
                                                                    <th style={{ 'minWidth': '150px' }}>Contact Person</th>
                                                                    <th style={{ 'minWidth': '150px' }}>Email ID</th>
                                                                    <th style={{ 'minWidth': '100px' }}>Phone</th>
                                                                    <th style={{ 'minWidth': '120px' }}>No of Licenses</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {results.map((option, index) => (
                                                                    <tr key={option.CompanyID} onClick={() => handleSearchChange([option])} style={{ cursor: 'pointer' }}>
                                                                        <td><Highlighter search={searchText}>{option.CompanyCode}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.CompanyName}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.ContactPerson}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.EmailID}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.Mobile}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.NoOfLicenses}</Highlighter></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                );
                                            }}
                                        />
                                        {/* <img src={searchIcon} alt="" onClick={handleSearchClick} className='p-1' style={{ cursor: 'pointer' }} /> */}
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            dropdownMode="select"
                                            placeholderText='From'
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            placeholderText='To'
                                            dropdownMode="select"
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                {/* <div className='customermanagement-header-btns add-btn' onClick={handleOpenModal}>
                                <Button><img src={add} alt="" className='filter-img' />Add Customer</Button>
                            </div> */}
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {moduleData?.CanCreate === true && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <CustomerManagementTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                handleOpenValueFilterModal={handleOpenValueFilterModal}
                                companyData={companyData}
                                loading={loading}
                                selectedColumns={selectedColumns}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                moduleData={moduleData}
                                totalDataCount={totalDataCount}
                                showSwitchModal={showSwitchModal}
                                setShowSwitchModal={setShowSwitchModal}
                                handleSwitchClientCancel={handleSwitchClientCancel}
                                handleSwitchClientConfirm={handleSwitchClientConfirm}
                                signInDetails={signInDetails}
                                setCompanyId={setCompanyId}
                                companyCode={companyCode}
                                customerManagementData={customerManagementData}
                                singleCustomerData={singleCustomerData}
                                userRefId={userRefId}
                                companyId={companyId}
                                signInType={signInType}
                                PreviousCompanyID={PreviousCompanyID}
                                PreviousSuperAdminID={PreviousSuperAdminID}
                                navigate={navigate}
                                showImageDiv={showImageDiv}
                                setShowImageDiv={setShowImageDiv}
                                moduleId={moduleId}
                            />
                        </div>
                    </div>
                </div>
            </Main>}
            {
                isModalOpen && <AddCustomerModal
                    open={isModalOpen}
                    handleClose={handleCloseModal}
                    singleCustomerData={singleCustomerData}
                    companyCode={companyCode}
                    customerManagementData={customerManagementData}
                    companyId={companyId}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    customerCustomFieldData={customerCustomFieldData}
                    fieldValues={fieldValues}
                    setFieldValues={setFieldValues}
                    checkedData={checkedData}
                    setCheckedData={setCheckedData}
                    dataLoading={dataLoading}
                />
            }
            {
                showColumnFilterModal && (
                    <CustomerFilterModal
                        showColumnFilterModal={showColumnFilterModal}
                        handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                        selectedColumns={selectedColumns}
                        handleSaveColumns={handleColumnSelectionChange}
                    />
                )
            }
            {
                showValueFilterModal && (
                    <CustomerValueFilterModal
                        showValueFilterModal={showValueFilterModal}
                        handleCloseValueFilterModal={handleCloseValueFilterModal}
                        selectedColumnValue={selectedColumnValue}
                        selectedColumnId={selectedColumnId}
                    />
                )
            }
            {
                showCustomerViewDetails && (
                    <CustomerViewDetails
                        showCustomerViewDetails={showCustomerViewDetails}
                        handleCloseViewDetails={handleCloseViewDetails}
                        handleAnalyticsClick={handleAnalyticsClick}
                        singleCustomerData={singleCustomerData}
                        companyCode={companyCode}
                        setShowCustomerViewDetails={setShowCustomerViewDetails}
                        customFields={customFields}
                        dataLoading={dataLoading}
                    />
                )
            }
        </div >
    );
};

export default CustomerManagement;